module.exports = __webpack_public_path__ + "img/keder_hellelfenbein_ral1015.d48595f7.jpg";